import { differenceInDays, startOfDay } from 'date-fns';
export const getMaturityText = ({ endDate, status, productOfferType }) => {
    const daysDifference = differenceInDays(new Date(endDate), startOfDay(Date.now()));
    if ((status === 'ACTIVE' || status === 'PAYOUT_IN_PROGRESS') && productOfferType !== 'SAVINGS_ACCOUNT') {
        if (daysDifference === 0) {
            return { message: 'CD has matured', toastMessage: 'Your CD has matured.' };
        }
        if (daysDifference > 0 && daysDifference <= 31) {
            return {
                message: `Maturing in ${daysDifference} ${daysDifference === 1 ? 'day' : 'days'}`,
                toastMessage: 'Your CD will be maturing soon.'
            };
        }
    }
    return { toastMessage: '', message: '' };
};
